import { CERTIFICATE_MODULE } from "@/api_framework/api_config";
import { useConfiguration } from "@/app/hooks/useConfiguration";
import axios, { AxiosError, AxiosResponse } from "axios";
import { useCallback, useState } from "react";
import toast from "react-hot-toast";
import AxiosCurlirize from "axios-curlirize";
import { useCurlLogger } from "@/app/hooks/useCurlLogger";
import { useAPIUtils } from "@/app/hooks/useAPIUtils";
import {
  ICertificatesDocumentDetailResponse,
  ICertificatesDocumentDetailResponseData,
} from "@/api_framework/api_modals/Certificates";

AxiosCurlirize(axios, () => {});
type InventoryTaxCreateAPIResponse = { status: boolean; message: string };

export const useDocumentDetailAPI = () => {
  const [documentDetail, setDocumentDetail] = useState<ICertificatesDocumentDetailResponseData>({
    document_files: [],
    document_id: "",
    document_type: "",
    pet_name: "",
    pet_id: "",
    remarks: "",
  });
  const configuration = useConfiguration();
  const { sendCurl } = useCurlLogger();
  const { captureError } = useAPIUtils();

  const execute = useCallback(
    async (customer_id: string, document_id: string) => {
      try {
        const accessToken = localStorage.getItem(configuration.localStorage.ACCESS_TOKEN.key);
        const response: InventoryTaxCreateAPIResponse = await axios
          .get(
            `${CERTIFICATE_MODULE?.DOCUMENT_DETAIL?.baseURL}?customer_id=${customer_id}&document_id=${document_id}`,
            {
              headers: {
                Authorization: `${accessToken}`,
                "Content-Type": "application/json",
              },
            },
          )
          .then((res: AxiosResponse<ICertificatesDocumentDetailResponse>) => {
            if (res.data.status) {
              setDocumentDetail(res.data.data);
              return { status: true, message: null };
            } else {
              setDocumentDetail(null);
              return { status: false, message: null };
            }
          })
          .catch((e: AxiosError) => {
            setDocumentDetail(null);
            sendCurl(e.config["curlCommand"]);
            return { status: false, message: null };
          });
        return response;
      } catch (error) {
        setDocumentDetail(null);
        if (axios.isAxiosError(error)) {
          captureError(error);
        } else {
          toast.error("Server Error: " + error.message);
        }
      }
    },
    [configuration],
  );

  return { execute, documentDetail };
};
